import { memo, useId } from "react";

import {
	AccordionContent,
	AccordionItem,
	Accordion as AccordionRoot,
	AccordionTrigger,
} from "@/components/ui/accordion/accordion";

type Props = {
	labelChildren?: React.ReactNode;

	children?: React.ReactNode;
};

export const Accordion = memo(({ labelChildren, children }: Props) => {
	const uniqueId = useId();

	return (
		<AccordionRoot type="single" collapsible>
			<AccordionItem value={uniqueId}>
				<AccordionTrigger arrowLeft={true}>{labelChildren}</AccordionTrigger>
				<AccordionContent className="px-5 py-3">{children}</AccordionContent>
			</AccordionItem>
		</AccordionRoot>
	);
});
